<svelte:options runes={false} />
<script>
  // Slice latency tile (TASK-20260823-twap-strategies-tca PR-C2): p50 / p95 of child place → resolve,
  // from one scorecard (contract: TwapScorecardResult.SliceLatencyP50Ms / P95Ms) or the tab's
  // latencyRollup. A missing figure is an honest "—" with the reason underneath.
  import { fmtLatency } from '../../../lib/twapReport.js';

  export let p50Ms = null;
  export let p95Ms = null;
  export let label = 'Slice latency';
  export let sub = 'placed → resolved, p50 / p95';
  export let loading = false;

  const isNum = (v) => typeof v === 'number' && Number.isFinite(v);
  $: has = isNum(p50Ms) || isNum(p95Ms);
</script>

<div class="lt" aria-busy={loading} title="Median and 95th-percentile time from a child order being placed to it resolving (filled, cancelled or expired)">
  <span class="lt-label">{label}</span>
  {#if loading && !has}
    <span class="lt-value num lt-muted">…</span>
  {:else}
    <span class="lt-value num"><span class="lt-p">p50</span> {fmtLatency(p50Ms)} <span class="lt-sep">/</span> <span class="lt-p">p95</span> {fmtLatency(p95Ms)}</span>
  {/if}
  <span class="lt-sub">{sub}</span>
</div>

<style>
  .lt { display: flex; flex-direction: column; gap: 0.15rem; min-width: 0; background: var(--bg-secondary, #111214); border: 1px solid var(--border-primary, #1e1f22); border-radius: var(--radius-base, 0.5rem); padding: 0.55rem 0.7rem; }
  .num { font-variant-numeric: tabular-nums; }
  .lt-label { font-size: var(--font-size-xs, 0.7rem); color: var(--text-secondary, #8a8b8d); text-transform: uppercase; letter-spacing: 0.04em; }
  .lt-value { font-size: var(--font-size-lg, 1.1rem); font-weight: var(--font-weight-semibold, 600); color: var(--text-primary, #fff); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .lt-p { font-size: var(--font-size-xs, 0.65rem); font-weight: var(--font-weight-normal, 400); color: var(--text-muted, #6a6b6d); text-transform: uppercase; }
  .lt-sep { color: var(--text-muted, #6a6b6d); font-weight: 400; }
  .lt-muted { color: var(--text-muted, #6a6b6d); }
  .lt-sub { font-size: var(--font-size-xs, 0.7rem); color: var(--text-muted, #6a6b6d); }
</style>
